<div class="container po-p-2">
  
  <div *ngIf="loading" class="po-text-center po-p-3">
    <po-spinner p-size="sm"></po-spinner> 
    <span class="po-ml-1 loading-text">Carregando componentes...</span>
  </div>

  <ng-container *ngIf="!loading">

    <div *ngIf="components && components.length > 0" class="components-list tabela-container-header">

      <po-table
        p-name="tabela-componentes-v3-final"
        p-sort
        p-striped
        [p-items]="components"
        [p-columns]="componentColumns"
        [p-hide-table-search]="false"
        [p-global-filter-properties]="filterFields"
        p-columns-manager>
      </po-table>

    </div> 

    <div *ngIf="!components || components.length === 0" class="po-font-text-large po-text-center po-p-3 po-text-color-07">
      Nenhum componente encontrado para este projeto.
    </div>

  </ng-container>

</div>